<template>

	<div class="container main-content">
		<div class="row">
			<div v-if="isProcessing" class="centered-absolute-spinner">
				<i class="fas fa-circle-notch fa-spin" style="font-size: 1.5rem"></i>
			</div>
			<div v-bind:class="[isProcessing ? 'bank-processing' : '', 'col-12 offset-md-2 col-md-8']">
				<div class="row mb-5">
					<div class="col-12 text-center mt-5">
						<h4 class="dark-highlight mb-5">Select your bank</h4>
						<div class="row">
							<div class="offset-2 col-8 offset-sm-0 col-sm-6 pl-5 pr-5 pt-4 pb-4" v-for="bank in getAvailableBanks()" v-bind:key="bank.bankCode" ><a href="#" @click.prevent="selectBank(bank.bankCode)" :title="bank.bankName"><img :src="getBankLogo(bank.bankCode)" :alt="bank.bankName" class="img-fluid" ></a></div>
						</div>

						<small class="error" v-if="hasError">{{ errorMessage }}</small>
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<p><small>By clicking your bank you will be taken to your bank's processing page.</small></p>
					</div>
				</div>
			</div>
		</div>
		
		
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			in_bank: '',
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			selectedBank: 'Abc',
			flowState: this.$gstate.getFlowState(),
		}
	},
	created(){
		eventBus.$on('nextScreen', this.storeBank);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.storeBank);
	},
	methods: {
		getAvailableBanks () {
			if (this.flowState.nextActionParams && this.flowState.nextActionParams.availableBanks) {
				return this.flowState.nextActionParams.availableBanks
			} else {
				return {}
			}
		},
		getBankLogo(bankCode){
			return '/static/img/banks/' + bankCode.toLowerCase() + '.png'
		},
		selectBank(bankCode){

			if(this.isProcessing){
				return;
			}

			this.isProcessing = true;
			this.hasError = false;

			this.$gstate.log("saving bank...");

			var urlstr = this.$gstate.getApiBaseRootURL() + '/banktransfer/init';
			this.axios.post(urlstr,{
				refId: this.$gstate.getRefId(),
				selectedBank: bankCode
			}, 
			this.$gstate.getAxiosHeaders()
			).then(response => {

					this.$gstate.log(response);
					this.isProcessing = false;
					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {

					this.$gstate.log("error:");
					this.$gstate.log(error.response);
					
					this.isProcessing = false;
					this.divStyle.opacity = 1.0;
					this.hasError = true;

					if(error.response.data.error.code == "FLOWACTION.INVALID"){
						this.errorMessage = "Unable to proceed as bank transfer has already been initiated.  Please contact customer support for further assistance.";
					} else {
						this.errorMessage = error.response.data.error.msg;
					}
					
				});

		}
	}
}
</script>
